const translations = {

  APP_NAME: 'theSafeZone',

  LOGIN: {
    HEADER: 'Inicia sesión en theSafeZone',
    EMAIL: 'Email',
    FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
    INVALID_EMAIL: 'El email introducido no es válido',
    INVALID_PASSWORD: 'La contraseña introducida debe tener al menos 6 caracteres',
    LOGIN: 'Iniciar sesión',
    PASSWORD: 'Contraseña',
    SIGN_UP: 'Regístrate',
  },

  SIGNUP: {
    HEADER: 'Regístrate en theSafeZone',
    ALREADY_REGISTERED: '¿Ya estás registrado?',
    COMPANY: 'Organización',
    EMAIL: 'Email',
    PASSWORD: 'Contraseña',
    CONFIRM_PASSWORD: 'Repetir Contraseña',
    SIGN_UP: 'Regístrate',
  },

  FORGOT_PASSWORD: {
    HEADER: '¿Olvidaste tu contraseña?',
    RECOVER_PASSWORD: 'Recuperar contraseña',
  },

  PASSWORD_RECOVERY: {
    HEADER: 'Restablecer contraseña',
    CHANGE_PASSWORD: 'Cambiar contraseña',
  },

  MENU: {
    LOGIN: 'Iniciar sesión',
    SIGN_UP: 'Registrarse',
    PROFILE: 'Mi perfil',
    HELP: 'Ayuda',
    LOGOUT: 'Cerrar sesión',
    REPORTS: 'Proyectos',
    SUBSCRIPTIONS: 'Suscripciones',
    SUPPORT: 'Soporte',
    USERS: 'Usuarios',
    PLANS: 'Planes',
    THESAFEZONE: 'Nuestra solución',
    MEREDICTE: 'Meredicte ©',
    BLOG: 'Blog',
  },

  SETTINGS: {
    SAVE: 'Guardar',
  },

  REPORT: {
    BUILDING: 'Nombre del sector',
  },

  ERROR: {
    INVALID_TOKEN: 'El token especificado no es válido',
    MAXIMUM_SESSIONS_EXCEEDED: 'Ya existe una sesión iniciada con las credenciales introducidas. Debe cerrar sesión antes de poder iniciar una nueva.',
    USER_ALREADY_EXISTS: 'El email especificado ya está dado de alta en el sistema',
    USER_NOT_FOUND: 'El usuario especificado no está dado de alta en el sistema',
    USER_NOT_VALIDATED: 'Debes validar la cuenta para poder acceder. Se envió un email tras el registro con instrucciones para validar la cuenta.',
    INVALID_PASSWORD: 'La contraseña introducida no es correcta',
    NAME_ALREADY_EXISTS: 'Ya existe un proyecto con este mismo nombre. Debe especificar uno nuevo.',
  },

  SUBSCRIPTIONS: {
    PURCHASE: 'Contratar',
  },

  FOOTER: {
    OUR_SOLUTION: 'Nuestra Solución',
    WHAT_IS: '¿Qué es Meredicte?',
    LEGAL_TERMS: 'AVISO LEGAL',
    USAGE_TERMS: 'TÉRMINOS DE USO',
    PRIVACY_POLICY: 'PRIVACIDAD',
    COOKIES: 'COOKIES',
    COPYRIGHT: 'Todos los derechos reservados',
  },

};

export default translations;



// WEBPACK FOOTER //
// ./src/translations/es-ES/translations.js